import React, {useEffect, useState} from "react";
import Header from "../../components/Header.js";
import {FormattedMessage, FormattedNumber, IntlProvider} from 'react-intl';
import * as StorageService from "../../services/StorageService.js";
import {EVENTS, FIREBASE_SCREEN_NAMES, HEADER_SIZE, LOCALSTORAGE_ITEMS} from "../../util/Constants.js";
import OrderSummActionsBar from "../../components/Actionsbar/OrderSummActionsBar.js";
import {DATE_FORMAT} from "../../util/DateUtil.js";
import * as ProductService from "../../services/ProductService";
import Moment from 'react-moment';
import {
    getAppLocale,
    getLastDay,
    getProdExtrasFromCart,
    getProdName,
    getProdOptionsFromCart,
    isShopOpen,
    sendEvent
} from "../../util/common";
import {EventBus} from "../../util/EventBus";
import {PATH} from "../../routes/routes.js";
import analyticsLogEvent from "../../services/FirebaseService";
import {useNavigate} from "react-router";

function TableOrderSummary() {
    const navigateTo = useNavigate();
    const userTable = StorageService.getItem(LOCALSTORAGE_ITEMS.USER_TABLE);
    const shopDetails = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS) ? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)) : null;
    const currency = shopDetails?.currency;
    const [state, setState] = useState({
        loading: false,
        subOrders: [],
        totalPrice: 0
    });


    useEffect(() => {
        analyticsLogEvent("screen_view", {
            firebase_screen: FIREBASE_SCREEN_NAMES.ORDER_SUMMARY,
            firebase_screen_class: FIREBASE_SCREEN_NAMES.ORDER_SUMMARY
        });
    }, []);


    const toPaymentPage = () => {
        navigateTo(PATH.PAYMENT);
    }

    const toAllProductsPage = () => {
        navigateTo(PATH.ALL_PRODUCTS);
    }

    const getAllProductsOrders = async () => {
        if (state.loading) {
            return;
        }
        setState({
            ...state,
            loading:true
        })



        const body = {
            "shop": StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME),
            "user": StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL),
            "fromDate": getLastDay()
           // "procStatus": ["OPEN", "CONFIRMED", "READY", "DELIVERED"]
        }

        const response = await ProductService.getAllProductsOrders(body);
        if (response.ok) {
            let currentOrder = null;
            const storageCurrentOrderId = StorageService.getItem(LOCALSTORAGE_ITEMS.ORDER_ID);
            for(let i=0; i < response.data.orders.length;i++){
                const o = response.data.orders[i];
                if(o.oid === storageCurrentOrderId){
                    currentOrder = o;
                    break;
                }
                if(currentOrder === null && o.procStatus === "OPEN"){
                    currentOrder = o;
                }
            }
            sendEvent({
                type: EVENTS.ACTIVE_ORDER,
                body: {
                    ...currentOrder,
                    shopTitle:shopDetails.title
                }
            });
            StorageService.setItem(LOCALSTORAGE_ITEMS.ALL_ORDER_PRODUCTS,JSON.stringify(currentOrder));

            setState({
                ...state,
                subOrders: groupOrderProductsByTime(currentOrder.products),
                loading: false,
                totalPrice: currentOrder.price
            })
        } else {
            EventBus.dispatch("genericErrorMsg");
            console.log("Error getting all product orders...");
            setState({
                ...state,
                loading:false
            })
        }
    }

    const handleOrderMoreAction = () => {
        if (!isShopOpen()) {
            EventBus.dispatch("shopIsClosed");
            return;
        }
        StorageService.removeItem(LOCALSTORAGE_ITEMS.CURRENT_CART);
        toAllProductsPage();
    }

    const groupOrderProductsByTime = (arr) => {
        let currentGroupArray = [];
        let finalGroupArray = [];
        let currentGroupTimestamp = 0;


        arr?.forEach(product =>{
            if (product.ts === currentGroupTimestamp) {
                currentGroupArray.push(product);
            }else{
                currentGroupTimestamp = product.ts;
                if (currentGroupArray.length>0) {
                    finalGroupArray.unshift(currentGroupArray);
                }
                currentGroupArray = [product];
            }
        });
        if (currentGroupArray.length>0) {
            finalGroupArray.unshift(currentGroupArray);
        }
        return finalGroupArray;
    }

    const getAllQuantytiesFromSuborder = suborder => {
        let quantity = 0;
        suborder.forEach(product => {
            quantity += product.quantity
        });
        return quantity;
    }

    const getFinalPriceFromSuborder = suborder => {
        let price = 0;
        suborder.forEach(product => {
            if (product.status==="CANCELED") {
                price-=product.quantity * product.price
            }else{
                price+=product.quantity * product.price
            }

        });
        return price;
    }


    useEffect(() => {
        let retrievedShopNameFromStorage =  StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME);

        if (!retrievedShopNameFromStorage ) {
            toAllProductsPage();
        }
        getAllProductsOrders();
    }, []);

    return (
        <>
            <Header
                headerSize={HEADER_SIZE.SMALL}
                headerTitle={<FormattedMessage id="OrderSummary"/>}
                hasBackBtn={true}
                hasModal={true}
            />
            <div className="order-details-top-msg">

               <div className="row">
                   <FormattedMessage id="YourOrderWillBeDelivered"/>
                   <span className="order-details-table" data-qa="order-details-table">&nbsp;{userTable}</span>
               </div>
                <div className="row">
                    <FormattedMessage id="OrderNumber"/>&nbsp;
                    <span className="order-number">#{StorageService.getItem(LOCALSTORAGE_ITEMS.ORDER_ID)}</span>
                </div>
                <div className="row">
                     <span className="total-price" data-qa={"order-summary-total-price"}>
                        <FormattedMessage id="Total"/>:&nbsp;
                         <IntlProvider locale={getAppLocale()}>
                                 <FormattedNumber
                                     value={state.totalPrice / 100.0}
                                     style="currency"
                                     minimumFractionDigits={2}
                                     maximumFractionDigits={2}
                                     currency={currency} />
                                 </IntlProvider>
                    </span>
                </div>
            </div>
            <main className="page-content order-summary-page-content">
                {!!state.subOrders.length && state.subOrders.map((suborder, index) => (
                    <section key={index+suborder} className="order-details-card">

                        <header className="order-details-card-header success">
                            <FormattedMessage id="OrderSentAt"/>
                            <span className="created-at">
                                     <Moment
                                         format={DATE_FORMAT.DEFAULT}
                                         date={suborder[0].ts}
                                     />
                                </span>
                        </header>
                        <div className="card-content">
                            {
                                suborder.map((product, index) => (
                                    <div key={index + product} >
                                        {product.status === "CANCELED" ?
                                            <div className="product canceled">
                                                <div className="row">
                                                    <div className="prod-name-and-qty">
                                                        <span className="prod-qty">{product.quantity}<span className="times">&times;</span></span>
                                                        <span className="prod-name">{getProdName(product)}</span>
                                                    </div>
                                                    <span className="prod-price">&nbsp;

                                                        <IntlProvider locale={getAppLocale()}>
                                                <FormattedNumber
                                                    value={product.price / 100}
                                                    style="currency"
                                                    minimumFractionDigits={2}
                                                    maximumFractionDigits={2}
                                                    currency={currency} />
                                                </IntlProvider>
                                                </span>
                                                </div>

                                                <div className="choices row">
                                                    {product.option?
                                                        <span>
                                                       {getProdOptionsFromCart(product)}
                                                            &nbsp;</span>
                                                        :null
                                                    }
                                                    {product.msg?
                                                        <span>{product.msg}&nbsp;</span>
                                                        :null
                                                    }
                                                </div>
                                            </div>
                                            :
                                            <div className="product">
                                                <div className="row">
                                                    <span className="prod-qty">{product.quantity}<span className="times">&times;</span></span>
                                                    <span className="prod-name">{getProdName(product)}</span>
                                                    <span className="prod-price">&nbsp;

                                                        <IntlProvider locale={getAppLocale()}>
                                                <FormattedNumber
                                                    value={product.price / 100}
                                                    style="currency"
                                                    minimumFractionDigits={2}
                                                    maximumFractionDigits={2}
                                                    currency={currency} />
                                                </IntlProvider>
                                                </span>
                                                </div>

                                                <div className="choices row">
                                                    {product.option?
                                                        <span>
                                                       {getProdOptionsFromCart(product)}
                                                            &nbsp;</span>
                                                        :null
                                                    }
                                                    {product.msg?
                                                        <span>{product.msg}&nbsp;</span>
                                                        :null
                                                    }
                                                </div>

                                                <div className="choices row">
                                                    {product.extras?
                                                        <>
                                                            {getProdExtrasFromCart(product)}
                                                        </>
                                                        :null
                                                    }
                                                </div>

                                            </div>

                                        }

                                        {index === (suborder.length - 1)?
                                            (
                                                <div className="total-container row">
                                                    <span className="total-prod-nr">{getAllQuantytiesFromSuborder(suborder)}&nbsp;</span>
                                                    <span className="total-prod-label">{getAllQuantytiesFromSuborder(suborder) !== 1 ?
                                                        <FormattedMessage id="Products"/> :
                                                        <FormattedMessage id="Product"/>}</span>

                                                    <span className="total-price">
                                                         <IntlProvider locale={getAppLocale()}>
                                                        <FormattedNumber
                                                            value={getFinalPriceFromSuborder(suborder) / 100.0}
                                                            style="currency"
                                                            minimumFractionDigits={2}
                                                            maximumFractionDigits={2}
                                                            currency={currency} />
                                                         </IntlProvider>
                                                        </span>

                                                </div>
                                            ) : null}
                                    </div>
                                ))
                            }
                        </div>
                    </section>
                ))
                }
            </main>

            <OrderSummActionsBar
                isVisible={true}
                buttonName={<FormattedMessage id="GetTheCheck"/>}
                dataQAIdentifier1={"order-summary-get-the-check-btn"}
                btnClassName={"btn btn-outlined btn-md"}
                buttonAction={() => {
                    toPaymentPage();
                }}

                buttonName2={<FormattedMessage id="OrderMore"/>}
                dataQAIdentifier2={"order-summary-order-more-btn"}
                btnClassName2={"btn btn-default btn-md"}
                buttonAction2={() => {
                 handleOrderMoreAction();
                }}
            />
        </>
    );
}

export default TableOrderSummary;
